
  var EMI;
//   P stands for the loan amount or principal
  var P = ( ProductJson.price / 100);
  var R = 12 / (12 * 100); // R is the interest rate per month [if the interest rate per annum is 11%, then the rate of interest will be 11/(12 x 100)],
  var N = 12; //N is the number of monthly installments
  var onePlusRPwrN = Math.pow((1 + R), N);
  EMI = Math.round((P * R * onePlusRPwrN) / (onePlusRPwrN - 1));

  if (P >= 2500) {
      $('#EMI').html(new Intl.NumberFormat("en-IN").format(EMI));
  }
  else {
      $("#EMI_Pop_Up_Li").css("display", "none");
      $('#nextLinePd').css("display", "block");
  }

$('#notifyPrd').on('click', (e) => {
  e.preventDefault();
  console.log("notify click");
  $('#tps-Modal-notify').css("display", "block");
  $('#campaignStickyHeader').css("display", "none");

});
$('#closeNotifyProduct').on('click', (e)=>{
  // e.preventDefault();
  console.log("notify click close");

  $('#tps-Modal-notify').css("display", "none");
      $('#campaignStickyHeader').css("display", "block");

  

  // console.log(ProductJson);
})

// console.log(handle);

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); // ((exdays*24*60*60*1000) - (45*60*1000)));//
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";secure;path=/;samesite=lax";
}


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

function recent_productCookie(a) {

  var product_handle = getCookie("rectprod").split(",");
  let repeat = product_handle[0].includes(handle);
  var prodRes = product_handle[0].split("/");

  // console.log(repeat);
//    console.log(handle);

  if (product_handle == "") {
      setCookie("rectprod", handle, 6);
  } else if (product_handle != "") {
      // splits the cookie string
      // splits cookie string above and creates as array
      // if the handle of current page is already exists in the cookie it will not add cookie again to avoid duplicate

      var rec_div = document.getElementById("recent_Title");
      if (prodRes.length > 0) { // if the cookie handle is more than products threshold

         if(prodRes[0] != handle){
            rec_div.style.display = "block";
         }

        //   if (prodRes.length > 7) { // The below logic removes the first handle on the array and add current handle at last fo array
        //   } else 

        if (prodRes.length < 9) {
              if (!repeat) {
                  setCookie("rectprod", (product_handle + "/" + handle), 6);
              }
              bulidProd(prodRes);
          } else if (prodRes.length == 9) {
              var item = prodRes[0];
              var index = prodRes.indexOf(item);
              if (index !== -1)
                  prodRes.splice(index, 1);



              // the below logic will convert array into string
              var afterRemString = prodRes[0];

              for (var f = 1; f < prodRes.length; f++) {
                  afterRemString = afterRemString + "/" + prodRes[f];
              }
              if (!repeat) {
                  setCookie("rectprod", (afterRemString + "/" + handle), 1);
              }
              // set the cookie


              bulidProd(prodRes);
          }

      } else { // bulidProd(prodRes);
          console.log("first product")
      }

  }

}

var removeDublicate = function (arr) {
  var result = []
  var sort_arr = arr.sort()
  for (var i = 0; i < arr.length; i++) {
      if (arr[i + 1] !== arr[i]) {
          result.push(arr[i])
      }
  };

  return result

};

window.addEventListener("load", recent_productCookie());

function bulidProd(Array) {
 
  var prodObject = []
  $.each(Array, getjson);
}

function getjson(index, item) {
    // console.log('getJson')
  const url = item + ".js";
  var oj;
  if (handle != item) {
      $.ajax({
          url: url,
          async: true,
          dataType: "json",
          success: function (response) {
              oj = response;
              // createProdeach(oj);
              let productDiv = TPSBuild.tps_product(oj);
              $('#recent').append($.parseHTML( productDiv ));
          }
      })
  }
}


let activeWish = false;
let activeCompare = false;

//click event for Compare product
$('#compareProduct').click(function () {
    //console.log("checked")
    if (activeCompare == false) {
        triggerAddStroage("compare", 4);
    }
    else if (activeCompare == true) {
        triggerRemoveStroage("compare");
    }
    setTimeout(closeWishNotify, 6000);
    location.reload(true);
});


//click event for the add to wishlist 
$('.WishIcon').click(function () {

    if (activeWish == false) {
        triggerAddStroage("wishlist", 10);
    }
    else if (activeWish == true) {
        triggerRemoveStroage("wishlist");
    }
    setTimeout(closeWishNotify, 6000);
});

function triggerAddStroage(localName, t) {
    var arrayname = localName;
    var threshold = t;

    if (typeof (Storage) !== "undefined") {

        if (localName == 'wishlist') {
            activeWish = true;
            setWish();
        }
        else if (localName == 'compare') {
            setCompare();
            activeCompare = true;


        }

        //check for the array exsits in client.

        var checkFlag = listChecker(arrayname, threshold);
        // console.log(checkFlag);
        addItemtoStorage(checkFlag, arrayname);
    }

    else {
        // local not avaliable
    }
}

function triggerRemoveStroage(localName) {
    var arrayName = localName;
    //console.log(arrayName);
    //console.log(activeWish);
    if (localName == 'wishlist') {
        removeWish();
        removeItem(localName);
        //   activeWish = false;

    }

    if (localName == 'compare') {
        removeCompare()
        removeItem(localName);

        //  activeCompare = false;
    }
    notify(arrayName, 0);
}

function removeItem(name) {
    var arrayString = localStorage.getItem(name);
    var array = arrayString.split(",");
    var handletoRemove = handle;
    const index = array.indexOf(handletoRemove);

    if (index > -1) {
        array.splice(index, 1);
    }
    localStorage.setItem(name, array);
}

function listChecker(name, limit) {

    let arrayString = localStorage.getItem(name);

    if (arrayString == null || arrayString == "") return 0;

    else {
        let array;
        array = arrayString.split(',');
        if (!(array.length >= limit)) {
            if (!(array.includes(handle))) {
                return 1
            }
            else {
                return -1
            };
        }
        else {
            if (!(array.includes(handle))) {
                return 2;
            }
            else {
                return -2;
            }
        }
    }
}

function addItemtoStorage(flag, name) {
    let f = flag;
    let n = name;
    let v = handle;

    //There is four condition 1, -1, 0
    // 1 = good to add; 
    // -1 = already exsists; 
    // 0 = new item; 
    // 2 = limit reached handle good to add in array, 
    // -2 = limit reached handle contains in array;

    //new item
    if (f == 0) {
        localStorage.setItem(n, v);
        notify(n, 1);
    }

    //good to add;
    else if (f == 1 || f == 2) {
        v = additem(n, f);
        // console.log(v)
        localStorage.setItem(n, v);
        notify(n, f);
    }

    //already exsists;
    else if (f == -1 || f == -2) {
        notify(n, f);
    }

}

function additem(name, flag) {

    var arrayString = localStorage.getItem(name);
    var array = arrayString.split(",");
    // array.push(handle);
    if (flag == 1) {
        array.push(handle);
    };

    if (flag == 2) {
        array.push(handle);
        array.shift();
    }

    return array;
}



function notify(name, flag) {
    let f = flag;
    //console.log(flag)
    if (f == 1 || f == 2) {

        if (name == 'wishlist') {
            $(".tps-wish-notify").html("ADDED TO WISHLIST");
            $(".tps-wish-notify").css("display", "block");
            $(".tps-wish-notify").css("background-color", "#fc3a52");
        }
        else if (name == 'compare') {
            $(".tps-wish-notify").html("ADDED TO COMPARE");
            $(".tps-wish-notify").css("display", "block");
            $(".tps-wish-notify").css("background-color", "#F9B248");
        }

    }
    else if (f == 0) {
        if (name == 'wishlist') {
            $(".tps-wish-notify").html("REMOVED FROM WISHLIST");
            $(".tps-wish-notify").css("display", "block");
            $(".tps-wish-notify").css("background-color", "#fc3a52");
        }
        else if (name == 'compare') {
            $(".tps-wish-notify").html("REMOVED FROM COMPARE");
            $(".tps-wish-notify").css("display", "block");
            $(".tps-wish-notify").css("background-color", "#F9B248");
        }
    }
    else if (f == -1 || f == -2) {
        if (name == 'wishlist') {
            $(".tps-wish-notify").html("THIS PRODUCT IS ALREADY ADDED");
            $(".tps-wish-notify").css("display", "block");
            $(".tps-wish-notify").css("background-color", "#fc3a52");
        }
        else if (name == 'compare') {
            $(".tps-wish-notify").html("THIS PRODUCT IS ALREADY ADDED");
            $(".tps-wish-notify").css("display", "block");
            $(".tps-wish-notify").css("background-color", "#F9B248");
        }

    }
}

$(document).ready(function () {
    let checkBeforeWishList = listChecker('wishlist');
    let checkBeforeCompare = listChecker('compare');

    //console.log(checkBeforeWishList)
    // console.log(checkBeforeCompare)

    if (checkBeforeWishList == -2 || checkBeforeWishList == -1) {
        setWish();
    }
    else {
        removeWish();
    }

    if (checkBeforeCompare == -2 || checkBeforeCompare == -1) {
        setCompare();
    }
    else {
        removeCompare();
    }
});


function setWish() {
    activeWish = true;
    $(".wish").css("fill", "#FC3A52");
}

function removeWish() {
    activeWish = false;
    $(".wish").css("fill", "#7B7B7B");
}

function setCompare() {
    activeCompare = true;
    $(".checkmark-compare").css({ 'background-color': '#f9b248', 'border': 'none' });
    $(".check").css("display", "block");
}

function removeCompare() {
    activeCompare = false;
    $(".checkmark-compare").css({ 'background-color': '#fff', 'border': '1px solid #000' });
    $(".check").css("display", "none");
}

function closeWishNotify() {
    $(".tps-wish-notify").css("display", "none");
}


$('#moreDetailsEMI').on('click', function () {
    //
    //console.log('moreDetailsEMI');
    $('#EMI_Pop_Up').toggle();
    DisableIcon(0);
    $('.close_EMI').on('click', function () {
        //console.log("close")
        DisableIcon(1);
        $('#EMI_Pop_Up').css("display", "none");
    });
})

function DisableIcon(f) {
    if (f == 0) {
        $('.google-rate').css("display", "none");
        $('.tps-compare-static').css("display", "none");
        $('#wa-chat-btn-root').css("display", "none");
    }
    else if (f == 1) {
        $('.google-rate').css("display", "block");
        if ($('#comparecount').html() != '0') { $('.tps-compare-static').css("display", "block") } else { $('.tps-compare-static').css("display", "none") }
        $('#wa-chat-btn-root').css("display", "block");
    }
}
//
var loadTrustedSeller = $('<div></div>');
var loadSecuredPayment = $('<div></div>');
var loadEasyReturnAndPayment = $('<div></div>');
$.ajax({
    url: '/pages/why-us',
    type: 'GET',
    success: function (data) {
        loadTrustedSeller = $('#TrustContent').html($(data).find('#second_Section').html())
    }
});
$.ajax({
    url: '/pages/payment',
    type: 'GET',
    success: function (data) {
        loadTrustedSeller = $('#PaymentContent').html($(data).find('#EasyPayment').html())
    }
});
$.ajax({
    url: '/pages/easy-returns',
    type: 'GET',
    success: function (data) {
        loadTrustedSeller = $('#ReturnContent').html($(data).find('#MainContent').html())
    }
});

//
$('#TrustedS').on('click', function () {
    $('#tps-Modal-trusted').toggle();
    DisableIcon(0);
    $('.close_Trust').on('click', function () {
        DisableIcon(1);
        $('#tps-Modal-trusted').css("display", "none");
        $('#campaignStickyHeader').css("display", "block");
        $('#campaignStickyHeaderMob').css("display", "block");
    });
    $('#campaignStickyHeader').css("display", "none");
    $('#campaignStickyHeaderMob').css("display", "none");
})
$('#SecureR').on('click', function () {
    $('#tps-Modal-payment').toggle();
    DisableIcon(0);
    $('.close_Payment').on('click', function () {
        DisableIcon(1);
        $('#campaignStickyHeader').css("display", "block");
        $('#campaignStickyHeaderMob').css("display", "block");
        $('#tps-Modal-payment').css("display", "none");
    });
    $('#campaignStickyHeader').css("display", "none");
    $('#campaignStickyHeaderMob').css("display", "none");
})
$('#EasyRR').on('click', function () {
    $('#tps-Modal-return').toggle();
    DisableIcon(0);
    $('.close_Return').on('click', function () {
        $('#campaignStickyHeaderMob').css("display", "block");
        $('#campaignStickyHeader').css("display", "block");
        DisableIcon(1);
        $('#tps-Modal-return').css("display", "none");
    });
    $('#campaignStickyHeaderMob').css("display", "none");
    $('#campaignStickyHeader').css("display", "none");
})



$(window).on('load', function () {
  
  if(COOLink != undefined){
    if (COOLink != '' ) {
        //country of origin
        COO = AjaxCallProd.asyncReadFileFromAsset(COOLink, 'COO');

        let Country = `
        ${COO[`${brand}`] == undefined ? 'Information unavailable' : `${COO[`${brand}`][`${productType}`] == undefined ? 'Information unavailable' : COO[`${brand}`][`${productType}`] == '' ? 'Information unavailable' : COO[`${brand}`][`${productType}`]}`}
    `;

       // let InnerTable = $('#tab-2 table tbody')[0].innerHTML;
       // $('#tab-2 table tbody').html("");
        $('#tab-2 table tbody').append(
            `
                <tr class="tech_row">
                    <td class="tech_col1">Country of Origin</td>
                    <td class="tech_col2">${Country}</td>
                </tr>
              
        `
        )
    }

}
});